import "./Header.css";
import ViewNotification from "./ViewNotification";
import UserInformation from "./UserInformation";
import { useAuth } from "../../contexts/AuthContext";
import { NavLink, useParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import ForceReloadButton from "../../components/Buttons/ForceReloadButton";

const Header = (props) => {
  const { menu, setMenu } = props;
  return (
    <div className="h-[105px] flex flex-col justify-between bg-[#618BCC] sm:bg-gradient-to-r from-[#618BCC] to-[#1c5880]">
      <div className="flex justify-between p-2">
        {/* <button
          onClick={() => setMenu(!menu)}
          className="hidden text-2xl px-4 portrait:block"
        >
          <i className="fas fa-angle-double-right"></i>
        </button> */}
        <div className="flex items-center">
          <button
            className={`text-[1.1rem] bg-[#0B3C5D30] hover:bg-[#0B3C5D50] text-white/70 hover:text-white px-2.5 py-1 rounded-lg ${menu
              ? ""
              : ""
              } w-full`}
            onClick={() => setMenu(!menu)}
          >
            <div className={menu ? "" : "rotate-180"}>
              <i className="fa fa-angle-double-right"></i>
            </div>
          </button>
        </div>
        <div className="flex justify-between items-center gap-2">
          <ForceReloadButton />
          <ViewNotification />
          <UserInformation />
        </div>
      </div>
      <TabsContainer menu={menu} />
    </div>
  );
};

const TabsContainer = ({ menu }) => {
  const { user, setUser } = useAuth();
  const { rolId } = useParams();
  useEffect(() => {
    setUser(user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navRef = useRef(null);

  useEffect(() => {
    const nav = navRef.current;
    if (!nav) return;

    const handleWheel = (e) => {
      if (e.deltaY !== 0) {
        e.preventDefault(); // Evita el scroll vertical
        nav.scrollLeft += e.deltaY; // Mueve horizontalmente
      }
    };

    nav.addEventListener("wheel", handleWheel, { passive: false });

    return () => nav.removeEventListener("wheel", handleWheel);
  }, []);

  return (
    <div
      className={`w-full bg-[#2F527B] p-1.5 text-white ${!menu ? "lg:w-[calc(100vw-270px)]" : "lg:w-[calc(100vw-65px)]"
        }`}
    >
      <nav
        ref={navRef}
        className="flex overflow-auto gap-1 scrollbar-hide overflow-ellipsis"
      >
        {user?.rols?.map((rol) => {
          const isActive = parseInt(rolId) === rol.id;
          return (
            <NavLink
              to={`/rol/${rol.id}/menu`}
              key={rol.id}
              className={`
                pt-2 px-4 pb-2 flex w-full gap-1 items-center cursor-pointer font-semibold drop-shadow-md duration-200 justify-center rounded-[5px]
                ${isActive ? "bg-white text-[#143f5f]" : ""}
              `}
            >
              <i className="fa-solid fa-street-view text-[15px]" />
              <span className="whitespace-nowrap text-sm">{rol.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};

export default Header;
